import { InsuranceCompany } from '../enums/insurance-company.enum.js';
import { JobType } from '../enums/job-type.enum.js';
/** Full-snapshot job retries, independent of SDK/HTTP request retries. */
export const importJobPolicies = {
    [JobType.ImportApi]: {
        [InsuranceCompany.Allianz]: {
            attempts: 3,
            backoff: { type: 'exponential', delay: 60_000 },
        },
        [InsuranceCompany.Atradius]: {
            attempts: 3,
            backoff: { type: 'exponential', delay: 120_000 },
        },
        [InsuranceCompany.Coface]: {
            attempts: 3,
            backoff: { type: 'exponential', delay: 300_000 },
        },
    },
    [JobType.ImportRatings]: {
        [InsuranceCompany.Allianz]: {
            attempts: 3,
            backoff: { type: 'exponential', delay: 60_000 },
        },
        [InsuranceCompany.Coface]: {
            attempts: 3,
            backoff: { type: 'exponential', delay: 300_000 },
        },
    },
};
export const importFailureAlertThreshold = 3;
